import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class BaocaoKsnktService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    })
  };
  urlRpKsTknkttNt = environment.apiUrl + environment.ver + '/RpKsTknkttNt';
  constructor(private http: HttpClient) {
  }
  /*START*1.1.	Thống kê người khuyết tật theo nhóm tuổi */
  getRpKsTknkttNt(filter: any) {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpKsTknkttNt + '/Get?' + queryString);
  }
  exportRpKsTknkttNt(filter: any): Observable<any> {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpKsTknkttNt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }
  /*END*1.1.	Thống kê người khuyết tật theo nhóm tuổi */

  /*START*1.2.	Thống kê người khuyết tật theo dạng tật */
  urlRpKsTknkttDt = environment.apiUrl + environment.ver + '/RpKsTknkttDt';
  getRpKsTknkttDt(filter: any) {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpKsTknkttDt + '/Get?' + queryString);
  }
  exportRpKsTknkttDt(filter: any): Observable<any> {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpKsTknkttDt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }
  /*END*1.2.	Thống kê người khuyết tật theo dạng tật */

  /*START*1.3.	Tỉ lệ số lượng người khuyết tật theo mức độ khuyết tật */
  urlRpKsTlnkttMdkt = environment.apiUrl + environment.ver + '/RpKsTlnkttMdkt';
  getRpKsTlnkttMdkt(filter: any) {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpKsTlnkttMdkt + '/Get?' + queryString);
  }
  exportRpKsTlnkttMdkt(filter: any): Observable<any> {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpKsTlnkttMdkt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }
  /*END*1.3.	Tỉ lệ số lượng người khuyết tật theo mức độ khuyết tật */

  /*START*1.5.	Thống kê dạng tật của người khuyết tật theo độ tuổi */
  urlRpKsDktNktDt = environment.apiUrl + environment.ver + '/RpKsDktNktDt';
  getRpKsDktNktDt(filter: any) {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpKsDktNktDt + '/Get?' + queryString);
  }
  exportRpKsDktNktDt(filter: any): Observable<any> {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpKsDktNktDt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }
  /*END*1.5.	Thống kê dạng tật của người khuyết tật theo độ tuổi */

  /*START*1.6.	Thống kê mức độ khuyết tật của người khuyết tật theo độ tuổi  */
  urlRpKsMdkttNt = environment.apiUrl + environment.ver + '/RpKsMdkttNt';
  getRpKsMdkttNt(filter: any) {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpKsMdkttNt + '/Get?' + queryString);
  }
  exportRpKsMdkttNt(filter: any): Observable<any> {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpKsMdkttNt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }
  /*END*1.6.	Thống kê mức độ khuyết tật của người khuyết tật theo độ tuổi */
}
